"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribeSlice = exports.selectUnsubscribe = exports.initialState = exports.fetchUnsubscribe = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _updateSubscription = _interopRequireDefault(require("../api/Customer/updateSubscription"));
const initialState = exports.initialState = {
  loading: false,
  error: null
};
const fetchUnsubscribe = exports.fetchUnsubscribe = (0, _toolkit.createAsyncThunk)('unsubscribe/fetchUnsubscribe', async (_ref, _ref2) => {
  let {
    offerId,
    isPauseActive,
    checkedReason
  } = _ref;
  let {
    rejectWithValue
  } = _ref2;
  try {
    const result = await (0, _updateSubscription.default)({
      offerId,
      status: isPauseActive ? 'terminated' : 'cancelled',
      cancellationReason: checkedReason
    });
    return result;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const unsubscribeSlice = exports.unsubscribeSlice = (0, _toolkit.createSlice)({
  name: 'unsubscribe',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchUnsubscribe.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchUnsubscribe.fulfilled, state => {
      state.loading = false;
    });
    builder.addCase(fetchUnsubscribe.rejected, (state, _ref3) => {
      let {
        payload
      } = _ref3;
      state.loading = false;
      if (payload) {
        state.error = payload;
      }
    });
  }
});
const selectUnsubscribe = state => state.unsubscribe;
exports.selectUnsubscribe = selectUnsubscribe;
var _default = exports.default = unsubscribeSlice.reducer;